import { getToken } from "../utils/authUtils";
import { parseJSON } from "./parseJSON";

const urlBase = `${process.env.API_URL}/OrdenDeVenta`;
const readUrl = (url = "") => `${urlBase}${url}`;

const genericBaseUrl = `${process.env.API_URL}/`;
const genericReadUrl = (url = "") => `${genericBaseUrl}${url}`;

export const getOrdenesDeVenta = async (params) => {
  const auth = `Bearer ${getToken()}`;
  const query = new URLSearchParams(params);

  // Obtén el valor del parámetro "sort"
  const sortParam = query.get("sort");
  if (sortParam) {
    // Agrega los nuevos parámetros "orderBy" y "orderType"

    query.set("orderBy", sortParam);
    query.set("orderType", "ASC");
  }
  // Verifica si el parámetro "sort" tiene un signo menos (-)
  if (sortParam && sortParam.startsWith("-")) {
    // Remueve el signo menos (-) y obtén el valor de "sort"
    const sortValue = sortParam.substring(1);

    // Agrega los nuevos parámetros "orderBy" y "orderType"
    query.set("orderBy", sortValue);
    query.set("orderType", "DESC");
  }
  query.delete("sort");

  let res = await fetch(readUrl(`?${query.toString()}`), {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });

  res = await parseJSON(res);

  return res.success;
};

export const createOrdenDeVenta = async (body) => {
  const auth = `Bearer ${getToken()}`;
  let res = await fetch(readUrl(``), {
    method: "POST",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  });

  res = await parseJSON(res);

  return res.success;
};

export const updateOrdenDeVenta = async (id, body) => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrl(`/${id}`), {
    method: "PATCH",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  });

  res = await parseJSON(res);

  return res.success;
};

// para export de ordenes de venta
export const exportOrdenesDeVenta = async (params) => {
  const auth = `Bearer ${getToken()}`;
  const query = new URLSearchParams(params);
  const res = await fetch(readUrl(`/export?${query.toString()}`), {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });
  const blob = await res.blob();
  return blob;
};

// PARA LOS FILTROS Y SELECTS DE ORDENES DE VENTA

export const fetchClientesOrdenDeVenta = async (params) => {
  const auth = `Bearer ${getToken()}`;
  const query = new URLSearchParams(params);

  let res = await fetch(readUrl(`/clientsList?${query.toString()}`), {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });
  res = await parseJSON(res);
  return res.success;
};

export const fetchSubClientesOrdenDeVentaPaginados = async (params) => {
  const auth = `Bearer ${getToken()}`;

  const query = new URLSearchParams(params);

  let res = await fetch(readUrl(`/subclientsList?${query.toString()}`), {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });

  res = await parseJSON(res);
  return res.success;
};

export const fetchSucursalesOrdenDeVenta = async () => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(genericReadUrl(`sucursal`), {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });
  res = await parseJSON(res);
  return res.success;
};

export const getCotizacionBySubClienteId = async (id) => {
  const auth = `Bearer ${getToken()}`;

  if (!id || id === "undefined") return [];

  let res = await fetch(readUrl(`/cotizaciones?subClienteId=${id}`), {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });
  res = await parseJSON(res);
  return res.success;
};

export const fetchCategoriasOrdenDeVenta = async () => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrl(`/categoryOV`), {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });
  res = await parseJSON(res);
  return res.success;
};

export const multiPatchEstados = async (body) => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrl(`/multiEstados`), {
    method: "PATCH",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  });

  res = await parseJSON(res);

  return res.success;
};
